import { BackendModule, ResourceKey } from "i18next";

const SySiteBackend: BackendModule & { siteApi: HTMLSySiteApiElement } = {
  type: 'backend',
  siteApi: null,
  init(_services, options: { siteApi: HTMLSySiteApiElement }, _i18nextOptions) {
    this.siteApi = options.siteApi;
  },
  read(language, _namespace, callback) {
    this.siteApi.getTranslationBundle(language)
      .then((translationBundle: ResourceKey) => {
        callback(null, translationBundle)
      });
  }
}

export default SySiteBackend
